import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  UserProfileCardComponent as CommonUserProfileCardComponent,
} from '@hglobal/common';

import { UserProfileCardComponent } from './user-profile-card.component';

@NgModule({
  declarations: [UserProfileCardComponent],
  imports: [
    CommonModule,
    CommonUserProfileCardComponent,
  ],
  exports: [UserProfileCardComponent],
})
export class UserProfileCardModule {
}
